import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormatService {

  private formatType = new BehaviorSubject<string>('CELULAR');
  formatType$ = this.formatType.asObservable();

  updateFormatType(newFormat: string): void {
    this.formatType.next(newFormat);
  }
  
  
}
